import {InteractionState} from "../abstract-interaction";
import {Feature, LineString, Point, Position} from "geojson";
import {DrawInteractionState} from "../abstract-draw";
import {EditorSplitPolygon} from "./editor-split-polygon";
import {GeometryUtil} from "../../geometry";

export class EditorSplitLinestring extends EditorSplitPolygon {
    protected aim: Feature<Point>;


    buildInitialState(initialState: DrawInteractionState): InteractionState {
        this.aim = this.createAIM();

        return super.buildInitialState(initialState);
    }

    async onMouseMove(state: DrawInteractionState, e: mapboxgl.MapMouseEvent) {
        this.snapPoint = this.controller.snapUtility.getFeaturePoint(e, {geometry: state.features.get(state.featureID)} as any);
        this.aim.geometry.coordinates = this.snapPoint.point as Position;
        this.displayDrawFeature(this.aim);
    }

    protected _isMapMarker(e: mapboxgl.MapMouseEvent): boolean {
        let features = this.controller.mapInstance.queryRenderedFeatures(e.point);
        return !!features.find((feature => {
            return feature.properties.id === 'aim';
        }));
    }

    async onClick(state: InteractionState, e: mapboxgl.MapMouseEvent): Promise<void> {
        let splittedPath, depth;
        if (!this._isMapMarker(e)) {
            return;
        }
        let feature = state.features.get(state.featureID) as Feature<LineString>
        let layerGeometry = this.controller.interaction.getLayerGeometry(state.featureID);

        this.snapPoint = this.controller.snapUtility.getFeaturePoint(e, {geometry: feature} as any);
        this.aim.geometry.coordinates = this.snapPoint.point as Position;
        this.displayDrawFeature(this.aim);
        if (this.snapPoint.type === 'vertex') {
            if (this.snapPoint?.layerGeometry?.geometry?.geometry?.type === "MultiLineString") {
                splittedPath = this.snapPoint?.path?.split('.');
                let index = parseInt(splittedPath.pop());
                depth = parseInt(splittedPath.pop());
                await this.layerGeometrySplit(layerGeometry, [
                    GeometryUtil.multiLineString([...feature.geometry.coordinates.slice(0, depth), [...feature.geometry.coordinates[depth].slice(0, parseInt(index) + 1)]]),
                    GeometryUtil.multiLineString([[...feature.geometry.coordinates[depth].slice(parseInt(index))], ...feature.geometry.coordinates.slice(depth + 1)]),
                ]);
            }
            else
                await this.layerGeometrySplit(layerGeometry, [
                    GeometryUtil.lineString(feature.geometry.coordinates.slice(0, parseInt(this.snapPoint.path) + 1)),
                    GeometryUtil.lineString(feature.geometry.coordinates.slice(parseInt(this.snapPoint.path)))
                ]);
        } else if (this.snapPoint.type === 'contour') {
            splittedPath = this.snapPoint?.path?.split('.');
            let index = parseInt(splittedPath.pop());
            if (this.snapPoint?.layerGeometry?.geometry?.geometry?.type === "MultiLineString") {
                depth = parseInt(splittedPath.pop());
                await this.layerGeometrySplit(layerGeometry, [
                    GeometryUtil.multiLineString([...feature.geometry.coordinates.slice(0, depth), [...feature.geometry.coordinates[depth].slice(0, index + 1), this.snapPoint.point]]),
                    GeometryUtil.multiLineString([[this.snapPoint.point, ...feature.geometry.coordinates[depth].slice(index + 1)], ...feature.geometry.coordinates.slice(depth + 1)]),
                ]);
            }
            else
                await this.layerGeometrySplit(layerGeometry, [
                    GeometryUtil.lineString([...feature.geometry.coordinates.slice(0, index + 1), this.snapPoint.point]),
                    GeometryUtil.lineString([this.snapPoint.point, ...feature.geometry.coordinates.slice(index + 1)]),
                ]);

        } else {
            return;
        }

        this.controller.reloadLayer(layerGeometry.document)
        this.mode.changeInteraction('select');
        this.controller.interaction.clearFocus(true);
    }
}